
<script>
import {bankingTransactions as columns} from '../../../tables'
import { tipeTrxBankindColors } from '../../../config/transaction'

export default {
  name: "banking-transaction-list",
  props: {
    path: {
      type: String,
      default: ''
    }
  },
  computed: {
    tipeTrxBankindColors,
    uri() {
      return (this.path !== '') ? this.path : this.routeUri('hyperion.finances.banking-transactions')
    },
    filteredRanges: {
      get() {
        return this.filters.date.map((o) => this.moment(o, 'YYYY-MM-DD'))
      },
      set(val) {
        this.filters.date = val.map((moment) => moment.format('YYYY-MM-DD'))
      }
    },
    pageSize() {
      return parseInt(this.items.per_page)
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      columns,
      items: {},
      loading: false,
      expand: false,
      loadingDownload: false,
      modal: {
        visible: false,
        item: {}
      },
      modalResp: {
        visible: false,
        item: {}
      },
      filters: {
        page: 1,
        per_page: 10,
        date: [],
        products: []
      }
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  methods: {
    handleAutocomplete(v, iteratee) {
      if (v.length === 0) {
        this.filters[iteratee] = []
      } else {
        this.filters[iteratee] = _.map(v, (o) => o.id)
      }
    },
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        page: 1,
        per_page: 10,
        terminal_id: '',
        merchant_id: '',
        service: '',
        merchant_name: '',
        q: '',
        date: []
      }
    },
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri(this.uri, {}, true), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
    handleDownload(e) {
      // window.open(this.exportUri, '_blank')
      this.loadingDownload = true

      let params = _.merge(this.filters, {
        timestamp: (new Date).getTime(),
        format: e.key
      })

      this.$http.get(this.routeUri('hyperion.finances.banking-transactions.export') + '?' + this.$qs.stringify(params))
      .then(() => this.handleSuccessResponse())
      .catch((error) => this.handleResponseError(error))
      .finally(() => this.loadingDownload = false)
    },
    showAmount(svc, req, res) {
      let value = req.data['4'] ? this.currency(req.data['4'].substring(0, req.data['4'].length - 2)) : '-'

      if (svc == 'CheckBalance') {
        value = (res.data != null && res.data['54']) ? this.currency(parseInt(res.data['54'].substring(8, 18))) : '-'
      }

      return value
    }
  }
}
</script>

<template>
  <a-card size="small" type="inner" :title="items.total > 0 ? 'Banking Transaction '+items.total +' record(s)' : 'Banking Transaction'">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-row :gutter="24" class="form-filter-wrapper" :class="expand ? 'expanded' : ''">

        <a-col :span="6">
          <a-input placeholder="Keyword.." v-model="filters.q" allowClear>
          </a-input>
        </a-col>

        <a-col :span="6">
          <a-range-picker :ranges="dateRanges" format="YYYY-MM-DD" v-model="filteredRanges" style="width: 100%"/>
        </a-col>

        <a-col :span="6">
          <a-input placeholder="Merchant Name" v-model="filters.merchant_name" allowClear>
          </a-input>
        </a-col>

        <a-col :span="6">
          <a-input placeholder="Terminal ID" v-model="filters.terminal_id" allowClear>
          </a-input>
        </a-col>

        <a-col :span="6">
          <a-input placeholder="Merchant ID" v-model="filters.merchant_id" allowClear>
          </a-input>
        </a-col>

        <a-col :span="6">
          <a-select v-model="filters.service" placeholder="please select your service">
            <a-select-option value="RequestTpkClear">Request TPK Clear</a-select-option>
            <a-select-option value="CheckBalance">Check Balance</a-select-option>
            <a-select-option value="TransferInquiryOnUs">Transfer Inquiry On Us</a-select-option>
            <a-select-option value="TransferInquiryOffUs">Transfer Inquiry Off Us</a-select-option>
            <a-select-option value="TransferOnUs">Transfer On Us</a-select-option>
            <a-select-option value="TransferOffUs">Transfer Off Us</a-select-option>
            <a-select-option value="Purchase">Purchase</a-select-option>
            <a-select-option value="VoidRequest">Void Request</a-select-option>
            <a-select-option value="PurchaseReversal">Purchase Reversal</a-select-option>
            <a-select-option value="VoidReversal">Void Reversal</a-select-option>
          </a-select>
        </a-col>

        <a-col :span="6">
          <a-select v-model="filters.status" placeholder="please select your status">
            <a-select-option value="">All</a-select-option>
            <a-select-option value="success">Success</a-select-option>
            <a-select-option value="failed">Failed</a-select-option>
          </a-select>
        </a-col>

      </a-row>
      <a-row>
        <a-col :span="24" class="text-right">
          <a-button type="primary" html-type="submit" icon="filter"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Search
          </a-button>
          <a-button class="ml-2" type="dashed" html-type="reset" icon="reload" @click="handleReset"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Reset
          </a-button>

          <a-dropdown>
            <a-menu slot="overlay" @click="handleDownload">
              <a-menu-item key="xlsx">
                <a-icon type="file-excel" theme="twoTone" two-tone-color="#52c41a"/> XLSX
              </a-menu-item>
            </a-menu>
            <a-button class="ml-2" type="dashed" shape="circle" icon="cloud-download" :style="{ display: expand ? 'inline-block' : 'none'}" :loading="loadingDownload"/>
          </a-dropdown>

          <a class="ml-2" @click="() => this.expand = !this.expand ">
            Filter
            <a-icon :type="expand ? 'up' : 'down'"/>
          </a>
        </a-col>
      </a-row>
    </a-form>

    <a-divider dashed/>

    <a-skeleton :loading="loading" active>
      <a-table :columns="columns" :dataSource="items.data" rowKey="transaction_ref_id"
               :pagination="{ pageSize: pageSize, current: items.current_page, total: items.total, showSizeChanger: true }"
               @change="tableChanged" :scroll="{ x: 2500, y: 500 }">
        <h5 slot="datetime" slot-scope="time" class="text-center">
          {{ moment(time).format('DD/MM/YYYY HH:mm:ss') }}
        </h5>

        <h5 slot="request" slot-scope="record">
          {{ record.request.data['43'] }}
        </h5>

        <div slot="services" slot-scope="record">
          <h4>
            {{ record.services }}
          </h4>
        </div>

        <h4 slot="amount" slot-scope="record">
          {{ showAmount(record.services, record.request, record.response) }}
        </h4>

        <h5 slot="terminal_id" slot-scope="record">
          {{ record.terminal_id }}
        </h5>

        <h5 slot="merchant_id" slot-scope="record">
          {{ record.merchant_id }}
        </h5>

        <h5 slot="branch_code" slot-scope="record">
          {{ record.branch_code }}
        </h5>

        <h5 slot="pan" slot-scope="record">
          {{ record.pan }}
        </h5>

        <h5 slot="account_number" slot-scope="record">
          {{ record.account_number }}
        </h5>

        <h5 slot="original_account" slot-scope="record">
          {{ record.original_account }}
        </h5>

        <h5 slot="original_account_name" slot-scope="record">
          {{ record.original_account_name }}
        </h5>

        <h5 slot="destination_account" slot-scope="record">
          {{ record.destination_account }}
        </h5>

        <h5 slot="destination_account_name" slot-scope="record">
          {{ record.destination_account_name }}
        </h5>

        <h5 slot="rrn" slot-scope="record">
          {{ record.rrn }}
        </h5>

        <h5 slot="stan" slot-scope="record">
          {{ record.stan }}
        </h5>

        <h5 slot="status" slot-scope="record">
          {{ record.status }}
        </h5>

        <h4 slot="rc" slot-scope="record">
          {{ record.rc }}
        </h4>

        <h4 slot="rc_description" slot-scope="record">
          {{ record.rc_description }}
        </h4>

        <div slot="response" slot-scope="record">
          <a-tooltip title="Response">
            <a-button size="small" icon="code" @click="() => modalResp = { visible: true, item: record.response }"/>
          </a-tooltip>
        </div>

      </a-table>
    </a-skeleton>

    <a-modal title="Response" v-model="modalResp.visible" @ok="() => modalResp = { visible: false, item: {} }">
      <div class="code-bg">
        <vue-json-pretty :data="modalResp.item" :deep="1"/>
        <div class="extra">
          <a-button type="link" icon="copy" size="small" @click="copy(JSON.stringify(modalResp.item, null, 1), 'Source has been successfully copied to your clipboard.')"/>
        </div>
      </div>
    </a-modal>
  </a-card>
</template>
